export const typeMachine = [
    { value: 'грузовой автомобиль', label: 'грузовой автомобиль' },
    { value: 'легковой автомобиль', label: 'легковой автомобиль' },
    { value: 'автобус', label: 'автобус' },
    { value: 'спец. автомобиль', label: 'спец. автомобиль' },
    { value: 'строительная машина', label: 'строительная машина' },
    { value: 'трамвай', label: 'трамвай' },
    { value: 'троллейбус', label: 'троллейбус' },
  ]